export const BILLING_CATEGORIES = {
  ENTERPRISE: 'enterprise',
  PREMIUM: 'premium',
  PROFESSIONAL: 'professional',
  STARTER: 'starter',
  FREE: 'free',
};

export const BILLING_RENEWAL_TYPES = {
  YEAR: 'year',
  MONTH: 'month',
};
